var GalleryWidget = function(element, options){
    this.settings = $.extend({}, this.defaults, options);
    this.element = element;
    this.$element = $(element);
    this.init();
};

GalleryWidget.prototype = {

    // shorthand for using prototype
    constructor : GalleryWidget,

    init : function(){
        var _this = this,
            $settingsContainer = _this.$element.find('.cms-settings-container');

        // Widget Settings
        if ( $settingsContainer.length && $.fn.sortable ) {
            _this.$element.find('.tab-container').removeClass('ui-loading-background bg-white');

            UI.setupTabs.standard( _this.element + ' .ig-widget-tab-link', _this.element + ' .ig-widget-tab' );

            // Slide sorting UI
            _this.$element.find('.cms-settings-container .sortable-list').sortable({
                forceHelperSize: true,
                forcePlaceholderSize: true,
                handle: '.sort-icon'
            });

            // Settings UI
            if ( ! $settingsContainer.hasClass('handlers-set') ){
                _this.eventHandlers();
                $settingsContainer.addClass('handlers-set');
            }

            // Store the slideTemplate HTML for future cloning
            if ( _this.settings.slideTemplate === undefined ){
                _this.settings.slideTemplate = _this.$element.find('.slide-clone-template .slide-container');
                // Remove the slideTemplate HTML from the widget so it doesn't get saved
                _this.$element.find('.slide-clone-template .slide-container').remove();
            }
        }

        // Front-end UI
        _this.youTubeAPI();
        _this.vimeoAPI();

        if ($.fn.gallery) _this.$element.find('.gallery-container').gallery();
    },

    eventHandlers : function(){
        var _this = this;

        _this.$element.find('.slide-list').on('click', '.edit-slide', function(e) {
            var $parent = $(this).closest('.slide-container');
            if ( !$parent.find('.slide-image-upload').hasClass('uploader-initialized') ){
                e.preventDefault();
                _this.initImageUpload( $parent.find('.slide-image-upload'), $parent.find('.image-slide-preview') );
                _this.initImageUpload( $parent.find('.slide-image-thumb-upload'), $parent.find('.media-image') );
            }
            // if we're in Form CMS, and settings are still hidden, show them
            if ($('html').hasClass('cms-qgiv') && $parent.find('.slide-settings').hasClass('hide-content')) {
                $parent.find('.slide-settings').toggleClass('hide-content')
            }
        });

        _this.$element.find('.slide-list').on('click', '.save-slide', function(e) {
            var $parent = $(this).closest('.slide-settings');

            e.preventDefault();

            _this.adjustScroll($parent, function() {
                $parent.addClass('hide-content');
            });
        });

        _this.$element.find('.slide-list').on('click', '.delete-slide', function(e) {
            var $parent = $(this).closest('.slide-container')

            e.preventDefault();

            _this.adjustScroll($parent, function() {
                $parent.remove();

                // Add hidden input "js-no-slides" if all slides are gone
                if ( _this.$element.find('.slide-container').length < 1 ) {
                    _this.$element.find('.slide-list').append('<input class="js-no-slides" type="hidden" name="slides" value="" />');
                }
            });

            $parent.fadeOut();
        });

        _this.$element.find('.slide-list').on('input blur', '.slide-title-field', function() {
            var value = $(this).val();

            $(this).closest('.slide-container').find('.slide-title').text( value );
        });

        _this.$element.find('.slide-list').on('input blur', '.slide-desc-field', function() {
            var value = $(this).val();

            $(this).closest('.slide-container').find('.slide-desc').text( value );
        });

        _this.$element.find('.add-slide').off('click').on('click', function(e) {
            var $parent = $(this).closest('.control-settings-tab-container'),
                $newSlide = _this.settings.slideTemplate.clone(),
                indexCount = $parent.find('.sortable-list .slide-container').length + 1;

            e.preventDefault();

            $newSlide.find('.cms-bypass-field').removeClass('cms-bypass-field');
            $newSlide
                .attr('id', $newSlide.attr('id').replace(/new/,indexCount))
                .html( $newSlide.html().replace(/new/g,indexCount) )
                .prependTo( $parent.find('.sortable-list') )
                .find('.edit-slide').trigger('click');
        });

        _this.$element.find('.slide-list').on('blur', '.parse-video-service', function() {
            var $el = $(this),
                $parent = $el.closest('.slide-container'),
                $thumb = $parent.find('.ui-media .media-image'),
                videoId = $( $el.attr('data-related-field') ).val(),
                videoType = $($(this).attr('data-video-type')).val(),
                thumbUrl;

            if ( videoType == 'vimeo' ) {
                // oEmbed API is the current standard for getting vimeo videos' data
                $.ajax({
                    dataType: "json",
                    url: 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + videoId + '&width=240&height=180',
                    success: function(data) {
                        thumbUrl = data.thumbnail_url
                        _this.updateThumbnail( $thumb, thumbUrl );
                    }
                });
            } else {
                thumbUrl = 'https://img.youtube.com/vi/' + videoId + '/1.jpg';
                _this.updateThumbnail( $thumb, thumbUrl );
            }
        });

        _this.$element.on('click', '.cms-settings-trigger', function(e) {
            var $parent = $(this).closest('.cms-control-wrapper'),
                $settings = $parent.find('.settings-icon');

            e.preventDefault();
            e.stopPropagation();

            if ( $settings.length ){
                $settings.trigger('click');
            }

            if ( _this.$element.find('.slide-list .slide-container').length == 0 ) {
                _this.$element.find('.add-slide').trigger('click');
            }
        });

    },

    initImageUpload : function( $element, $updateTarget ) {
        var _this = this,
            formID = $('#form-id').val(),
            slideContainer = $element.closest('.slide-container').attr('id');

        if ( $('#registrant-id').length && !$('#is_admin').length ){
            var actionID = $('#registrant-id').val(),
                actionURL = '/event/account/' + actionID + '/upload?resize=1&context=media';

        } else {
            var actionID = formID,
                actionURL = '/control/forms/' + formID + '/cms-upload?resize=1&context=media';
        }

        if ( !$element.hasClass('uploader-initialized') ){
            var uploader = new qq.FileUploaderBasic({
                // pass the dom node (ex. $(selector)[0] for jQuery users)
                button: $element[0],
                // path to server-side upload script
                action: actionURL,
                allowedExtensions: ['jpg', 'jpeg', 'gif', 'png', 'pjpeg'],
                sizeLimit: 10500000, // in kb
                onSubmit: function(id, fileName){
                    // Show loading
                    $('#' + slideContainer).find('.ui-loading-overlay').fadeIn();
                },
                onProgress: function(id, fileName, loaded, total){},
                onComplete: function(id, fileName, response){
                    //hide loading
                    $('#' + slideContainer)
                        .find('.upload-error').remove().end()
                        .find('.ui-loading-overlay').fadeOut();

                    if ( response.success && response.url ) {
                        var imgPath = response.url,
                            $parent = $updateTarget.closest('.slide-container'),
                            $thumb = $parent.find('.ui-media .media-image');

                        // Update the main image in the UI if display is set to 'image'
                        if ( $element.hasClass('slide-image-upload') ) {
                            if ( $updateTarget.find('img').length ){
                                $updateTarget.find('img').attr('src', imgPath);
                            } else {
                                $updateTarget.append('<img src="' + imgPath + '" />');
                            }

                            $parent.find('.hidden-input-image').val( response.url );
                        }

                        // Now that there are slides, remove the "js-no-slides" hidden input if it exists
                        if ( _this.$element.find('.js-no-slides').length ) {
                            _this.$element.find('.js-no-slides').remove();
                        }

                        // Either way, load the thumbnail
                        _this.updateThumbnail( $thumb, response.thumb );
                    } else if ( response.errors ) {
                        _this.showMessage(response.errors[0], '#' + slideContainer);
                    } else {
                        _this.showMessage('Sorry, there was an issue uploading your file.', '#' + slideContainer);
                    }
                },
                onError: function(id, fileName, xhr){
                    $('#' + slideContainer).find('.ui-loading-overlay').fadeOut();
                },
                messages: {
                    typeError: "That file type isn't accepted. Only {extensions} files are allowed.",
                    sizeError: "{file} is too large, maximum file size is {sizeLimit}.",
                    minSizeError: "{file} is too small, minimum file size is {minSizeLimit}.",
                    emptyError: "{file} is empty, please try again.",
                    onLeave: "Your file is being uploaded, if you leave this page the upload will be cancelled."
                },
                showMessage: function(message){
                    _this.showMessage(message, '#' + slideContainer);
                }
            });

            $element.addClass('uploader-initialized');
        }
    },

    showMessage : function(message, target) {
        Message.target = target;
        Message.setMessage( message );
        Message.type = 'upload-error error';
        Message.scrollToMessage = false;
        Message.postMessage();
    },

    youTubeAPI : function() {
        var _this = this;

        if ( window.YTAPIReady ) {
            _this.$element.find('.video-slide.youtube').each(function() {
                var $videoDiv = $(this).find('.ui-embedded-media'),
                    videoInstance = $videoDiv.attr('id'),
                    videoWidth = $videoDiv.attr('data-video-width'),
                    videoHeight = $videoDiv.attr('data-video-height'),
                    videoID = $videoDiv.attr('data-video-id');

                if ( $('#' + videoInstance).is('div') ) {
                    YTplayers[videoInstance] = new YT.Player(videoInstance, {
                        videoId: videoID,
                        width: videoWidth,
                        height: videoHeight,
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        },
                        params: {
                            html5: 1
                        },
                        origin: window.location.protocol + '//' + window.location.host
                    });
                }
            });
        } else {
            setTimeout(function() {
                _this.youTubeAPI();
            }, 1000);
        }

        /* Pause Videos when a slide is hidden */
        function onPlayerReady(event){
            $('.video-slide.youtube').off('slideHidden').on('slideHidden', function() {
                var videoInstance = $(this).find('iframe').attr('id');

                if( YTplayers && videoInstance && YTplayers[videoInstance] && YTplayers[videoInstance].getPlayerState ) {

                    if ( YTplayers[videoInstance].getPlayerState() === YT.PlayerState.PLAYING || YTplayers[videoInstance].getPlayerState() === YT.PlayerState.BUFFERING ) {
                        YTplayers[videoInstance].pauseVideo();
                    }
                }
            });
        }

        function onPlayerStateChange(event) {
            var $target = $( '#' + event.target.h.id ),
                $element = $target.closest('.widget').find('.image-slideshow'),
                gallery = $element.data('qg_gallery'),
                displayType = $element.attr('data-type');

            if ( displayType === 'slideshow' ) {
                if ( event.data === YT.PlayerState.PLAYING || event.data === YT.PlayerState.BUFFERING ) {
                    gallery.pauseSlideshow();
                }
            }
        }
    },

    vimeoAPI : function() {
        var _this = this;

        $('.video-slide.vimeo').each(function() {
            var $iframe = $(this).find('iframe'),
                player_id = $iframe.attr('id'),
                frameEl = document.getElementById( player_id );

            // Check if we already did this
            if ( ! $iframe.hasClass('has-handler') ) {
                $iframe.off('load').on('load', function() {
                    // Make sure this only happens once
                    $iframe.addClass('has-handler');

                    vimeoPlayers[player_id] = new Vimeo.Player(frameEl);

                    // Make sure it's not null before adding event
                    if ( vimeoPlayers[player_id] ) {
                        vimeoPlayers[player_id].on('play', function(player) {
                            var $target = $('#' + player_id),
                                $element = $target.closest('.widget').find('.image-slideshow'),
                                gallery = $element.data('qg_gallery'),
                                displayType = $element.attr('data-type');

                            if ( displayType == 'slideshow' ) {
                                gallery.pauseSlideshow();
                            }
                        });
                    }
                });
            }
        });

        // listen for hidden slides and pause active videos
        $('.video-slide.vimeo').off('slideHidden').on('slideHidden', function() {
            var player_id = $(this).find('iframe').attr('id');

            if (player_id && vimeoPlayers[player_id]) {
                vimeoPlayers[player_id].pause();
            }
        });
    },

    updateThumbnail : function( $thumb, thumbUrl ) {
        var _this = this,
            $parent = $thumb.closest('.slide-container');

        if ( $thumb.find('img').length ) {
            $thumb.find('img').attr('src', thumbUrl );
        } else {
            $thumb.append('<img src="' + thumbUrl + '" />')
        }

        $parent.find('.hidden-input-thumb').val( thumbUrl );
    },

    adjustScroll : function( $parent, callback ) {
        var _this = this,
            scrollTarget = ($('body').css('overflow') == 'visible') ? 'body' : '.page-container',
            scrollLength = ($('body').css('overflow') == 'visible') ? _this.$element.offset().top : $( scrollTarget ).scrollTop() + _this.$element.offset().top;

        // Scroll up
        $( scrollTarget ).animate({
            scrollTop: scrollLength
        }, {
            speed: 300,
            complete: function() {
                if (typeof callback === 'function') {
                    callback.call();
                }
            }
        });
    }
};

var IGWidget = new GalleryWidget();